
export function initializeMemberAuthHandlers() {
    $(".file-block-row").each(function () {
        const $block = $(this);
        const requiresMembership = String($block.data("requires-membership")) === "true";
        const token = sessionStorage.getItem("memberToken");
        const membershipChecked = sessionStorage.getItem("membershipChecked");

        if (!requiresMembership) return;

        if (membershipChecked == "false") {
            $block.find(".member-access-container").hide();
            $block.find(".member-download-section").show();
            return;
        }

        if (token) {
            $.ajax({
                url: "/api/membership/validate-token",
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                success: function () {
                    $block.find(".member-access-container").hide();
                    $block.find(".member-download-section").show();
                    sessionStorage.setItem("membershipChecked", "false");
                   
                },
                error: function () {
                    sessionStorage.removeItem("memberToken");
                    $block.find(".member-access-container").show();
                }
            });
        } else {
            $block.find(".member-access-container").show();
        }

   
        $block.find("#phone-member-button").off("click").on("click", function (event) {
            event.preventDefault();
            const $form = $(this).closest(".membership-verification-form");
            const $messageBox = $form.find(".membership-validation-message");
            const phone = $form.find(".phone-input").val().trim();

            $messageBox.text("").removeClass("text-danger text-success");

            if (!/^\d{8}$/.test(phone)) {
                $messageBox.addClass("text-danger").text("Vennligst skriv inn et gyldig mobilnummer med 8 sifre.");
                return;
            }

            $block.find(".member-access-wrapper").hide();
            $block.find(".otp-loading").show();

            $.ajax({
                url: `/api/membership/verify?phoneNumber=${phone}`,
                method: "GET",
                success: function (data) {
                    $block.find(".otp-loading").hide();
                    if (data.success) {
                        showOTPForm($block, phone);
                    } else {
                        $block.find(".member-access-wrapper").show();
                        $messageBox.addClass("text-danger").text(data.message || "Noe gikk galt. Prøv igjen.");
                    }
                },
                error: function (xhr) {
                    $block.find(".otp-loading").hide();
                    const response = xhr.responseJSON || {};
                    $block.find(".member-access-wrapper").show();
                    $messageBox.addClass("text-danger").text(response.message || "Feil ved innsending. Prøv igjen senere.");
                }
            });
        });
    });
}

function showOTPForm($block, phone) {
    const $container = $block.find(".otp-verification-container");

    $block.find(".member-access-container").show();

    $container.html(`
        <div class="otp-form mt-3">
            <input type="hidden" name="phoneHidden" value="${phone}" />
            <div class="form-group d-flex flex-column">
                <label>Engangskode</label>
                <input type="text" inputmode="numeric" name="otpInput" class="form-control" />
                <small class="form-text text-muted">Du vil motta en engangskode på SMS dersom du er medlem og telefonnummeret er registrert hos oss.</small>
            </div>
            <button type="button" class="secondary-btn mt-2">Bekreft kode</button>
            <div class="otp-validation-message mt-2 small"></div>
        </div>
    `).show();

    $container.find("button").off("click").on("click", function (e) {
        e.preventDefault();

        const code = $container.find("input[name='otpInput']").val().trim();
        const phoneHidden = $container.find("input[name='phoneHidden']").val();
        const $otpBox = $container.find(".otp-validation-message");

        $otpBox.text("").removeClass("text-danger text-success");

        if (!/^\d+$/.test(code)) {
            $otpBox.addClass("text-danger").text("Vennligst skriv inn kun tall.");
            return;
        }

        $block.find(".membership-verification-container").hide();
        $block.find(".otp-loading").show();

        $.ajax({
            url: `/api/membership/verify-code?phoneNumber=${phoneHidden}&code=${code}`,
            method: "POST",
            success: function (data) {
                $block.find(".otp-loading").hide();

                if (data.success) {
                    $container.hide();
                    $block.find(".member-download-section").show();
                    sessionStorage.setItem("memberToken", data.token);
                    location.reload()
                } else {
                    $otpBox.addClass("text-danger").text(data.message || "Ugyldig kode. Prøv igjen.");
                    $block.find(".membership-verification-container").show();
                }
            },
            error: function (xhr) {
                $block.find(".otp-loading").hide();
                const response = xhr.responseJSON || {};
                $otpBox.addClass("text-danger").text(response.message || "Feil ved innsending. Prøv igjen senere.");
                $block.find(".membership-verification-container").show();
            }
        });
    });
}


$(document).ready(function () {
    initializeMemberAuthHandlers();
});
